import { GetProps, styled, YStack } from '@mythical/ui'

export const Container = styled(YStack, {
  w: '100%',
  variants: {
    variant: {
      none: {},
      smaller: {
        maxWidth: 500,
      },
      small: {
        maxWidth: 640,
      },
      medium: {
        maxWidth: 768,
      },
      mediumLarge: {
        maxWidth: 960,
      },
      large: {
        maxWidth: 1024,
      },
      full: {
        maxWidth: 1440,
      },
      ultraWide: {
        maxWidth: 2560,
      },
    },
    centered: {
      true: {
        mx: 'auto',
      },
    },
    paddedX: {
      true: {
        px: '$3.5',
      },
    },
  } as const,
  defaultVariants: {
    variant: 'medium',
    centered: true,
  },
})

export type ContainerProps = GetProps<typeof Container>
